import { apiService } from "./apiService";

const TASK_URL = "/task";
const params = { task_idx: process.env.REACT_APP_STT_RESULT_AI as string };
const wordParams = { task_idx: process.env.REACT_APP_STT_WORD as string };

export const getTaskList = async (): Promise<GetTaskListResponse> => {
  try {
    const response = await apiService.get<GetTaskListResponse>(`${TASK_URL}/list`, params);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getWordTaskList = async (): Promise<GetTaskListResponse> => {
  try {
    const response = await apiService.get<GetTaskListResponse>(`${TASK_URL}/list`, wordParams);
    return response;
  } catch (error) {
    throw error;
  }
};

export const putTaskList = async (data: PutTaskProps): Promise<PutTaskResponse> => {
  try {
    const response = await apiService.put<PutTaskResponse>(`${TASK_URL}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
